import { render } from "./dataPrivacy.vue?vue&type=template&id=15bab470&scoped=true"
const script = {}

import "./dataPrivacy.vue?vue&type=style&index=0&id=15bab470&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15bab470"]])

export default __exports__